import React, { useEffect, useState } from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    DeleteWithConfirmButton,
    SelectInput,
    Filter,
    useNotify,
    useRefresh, EditButton
} from 'react-admin';
import { makeStyles } from "@material-ui/core/styles";

const HolidayFilter = (props) => (
    <Filter {...props}>
        <SelectInput
            source="month"
            label="Month"
            choices={[
                { id: '1', name: 'January' },
                { id: '2', name: 'February' },
                { id: '3', name: 'March' },
                { id: '4', name: 'April' },
                { id: '5', name: 'May' },
                { id: '6', name: 'June' },
                { id: '7', name: 'July' },
                { id: '8', name: 'August' },
                { id: '9', name: 'September' },
                { id: '10', name: 'October' },
                { id: '11', name: 'November' },
                { id: '12', name: 'December' },
            ]}
        />
    </Filter>
);

// Define custom styles for the header
const useStyles = makeStyles({
    headerCell: {
        backgroundColor: '#def',
        fontWeight: 'bold', // Bold font
        textAlign: 'center', // Center text alignment
        padding: '10px', // Add padding for spacing
    },
});

const HolidayList = (props) => {
    const classes = useStyles();
    const [holidays, setHolidays] = useState([]);
    const [total, setTotal] = useState(0);
    const notify = useNotify(); // Call hooks here
    const refresh = useRefresh(); // Call hooks here

    return (
        <List
            {...props}
            bulkActionButtons={false}
            filters={<HolidayFilter />}
            data={holidays}
            total={total}
        >
            <Datagrid rowClick="edit" classes={{ headerCell: classes.headerCell }}>
                <TextField source="branchName" label="Branch Name" />
                <DateField source="holiday_date" label="Holiday Date" />
                <TextField source="description" label="Description" />
                <EditButton />
                <DeleteWithConfirmButton confirmTitle={"Delete?"} confirmContent={"Do you want to delete this record?"} />
            </Datagrid>
        </List>
    );
};

export default HolidayList;
